import {
  faAt,
  faBuildingUser,
  faUser,
  faUserTie
} from '@fortawesome/pro-regular-svg-icons'

export const ApplicantIcon = faUser
export const ContactIcon = faBuildingUser
export const UserIcon = faUserTie
export const ExternalRecipientIcon = faAt
